module.exports = __webpack_public_path__ + "static/media/shieldShape21.349518b7.png";